'use strict';

var UserSummaryPanelDirective = function UserSummaryPanelDirective() {
  return {
    restrict: 'E',
    template: require('../templates/user-summary-panel.html'),
    controller: require('../controllers/UserSummaryPanelController'),
    scope: {
      buttonOk: '=',
      buttonText: '=',
      destScreen: '='
    }
  };
};
UserSummaryPanelDirective.$inject = [];
module.exports = UserSummaryPanelDirective;